import {reverseMap} from 'services/utils/functions/reverseMap';
import {CodeListRef} from 'schemas/references/CodeListRef';

type GrepYearLevel =
  | 'aarstrinn1'
  | 'aarstrinn2'
  | 'aarstrinn3'
  | 'aarstrinn4'
  | 'aarstrinn5'
  | 'aarstrinn6'
  | 'aarstrinn7'
  | 'aarstrinn8'
  | 'aarstrinn9'
  | 'aarstrinn10'
  | 'vg1'
  | 'vg2'
  | 'vg3';

type GrepYearLevelToEducationLevelMapping = {
  [code in GrepYearLevel]: string;
};
export const grepYearLevelToEducationLevelMap: GrepYearLevelToEducationLevelMapping =
  {
    aarstrinn1: CodeListRef.EDUCATION_LEVEL['1. trinn'],
    aarstrinn2: CodeListRef.EDUCATION_LEVEL['2. trinn'],
    aarstrinn3: CodeListRef.EDUCATION_LEVEL['3. trinn'],
    aarstrinn4: CodeListRef.EDUCATION_LEVEL['4. trinn'],
    aarstrinn5: CodeListRef.EDUCATION_LEVEL['5. trinn'],
    aarstrinn6: CodeListRef.EDUCATION_LEVEL['6. trinn'],
    aarstrinn7: CodeListRef.EDUCATION_LEVEL['7. trinn'],
    aarstrinn8: CodeListRef.EDUCATION_LEVEL['8. trinn'],
    aarstrinn9: CodeListRef.EDUCATION_LEVEL['9. trinn'],
    aarstrinn10: CodeListRef.EDUCATION_LEVEL['10. trinn'],
    vg1: CodeListRef.EDUCATION_LEVEL['VG1'],
    vg2: CodeListRef.EDUCATION_LEVEL['VG2'],
    vg3: CodeListRef.EDUCATION_LEVEL['VG3'],
  };

export const mapEducationLevelToGrepYearLevel = (
  educationLevel: string,
): GrepYearLevel | undefined => {
  return (
    reverseMap(educationLevel, grepYearLevelToEducationLevelMap) ?? undefined
  );
};

export const hasMappableGrepYearLevel = (grepYearLevels: string[]): boolean => {
  const mappableGrepYearLevels = Object.keys(grepYearLevelToEducationLevelMap);
  return (
    grepYearLevels.filter(grepYearLevel =>
      mappableGrepYearLevels.includes(grepYearLevel),
    ).length > 0
  );
};
